<template>
  <section id="departs">
    <v-sub_banner :msgObj="subBannerInfo"></v-sub_banner>
    <b-container fluid>
      <b-row class="justify-content-center">
        <b-col cols="11" sm="10" md="9" xl="8" class="bgco">
          <div class="departments">
           
            <b-tabs content-class="mt-4"   pills class="coreTabs depTabs">
              <b-tab
                v-for="(item, index) in tabTitles"
                :key="index"
                :title="item.name"
                :active="index === 0 ? true : false"
                @click="handleClick(item.type)"
                class="tab-items"
              >   
              </b-tab>
            </b-tabs>
     
            <div class="rightBlock">
                  <div
                    class="out_box"
                    v-if="
                      activeName == 'partyActivities' ||
                      activeName == 'committee' ||
                      activeName == 'branchElegant' ||
                      activeName == 'learnResource'
                    "
                    
                  >
                    <div class="nodata" v-if="!lineList.length">
                    <el-empty></el-empty>
                    </div>
                    <div
                      class="itemBox"
                      v-for="item in lineList"
                      :key="item.id"
                      @click="goDetail(item)"
                      v-else
                    >
                      <span>{{ item.name }}</span>
                      <span>{{ item.time | parseDataConcise }}</span>
                    </div>
                  </div>
                 
              
            </div>
            
          </div>
            
        <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :pager-count="5"
                @current-change="handleChange"
                ></el-pagination>
        </b-col>
      </b-row>
      
    </b-container>
  </section>
</template>
<script>
import Sub_banner from "../sub-banner.vue";
export default {
  components: {
    "v-sub_banner": Sub_banner,
  },
  data() {
    return {
      subBannerInfo: {
        // img: require("@/assets/images/sub_banner/jgsz.png"),
        img: require("@/assets/images/connect_banner.png"),

        title: "党建之窗",
        subTitle: "Window of Party Building",
      },
      activeName: "partyActivities",

      tabTitles: [
        {
          id: "0",
          name: "党建之窗",
          type: "partyActivities",
        },
        {
          id: "1",
          name: "党建活动",
          type: "committee",
        },

        {
          id: "2",
          name: "学习资源",
          type: "learnResource",
          // type: "video",
        },
        {
          id: "3",
          name: "支部风采",
          type: "branchElegant",
        },
      ],
      lineList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      queryInfo: {
        currentPage: 1,
        pageSize: 10,
      },
      // recourseList:[]
    };
  },
  watch: {},
  created() {
    this.handleClick();
  },
  mounted() {
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      let screenWidth = window.innerWidth;
      this.setReSize(screenWidth);
    };
    this.setReSize(window.innerWidth);
  },
  methods: {
    setReSize(screenWidth) {
      if (screenWidth > 576) {
        this.subBannerInfo.img = require("@/assets/images/connect_banner.png");
      } else {
        this.subBannerInfo.img = require("@/assets/images/common_m.png");
      }
    },
    formate_Date(time) {
      time = new Date(time);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();

      if (month < 10) {
        month = "0" + month;
      }

      if (day < 10) {
        day = "0" + day;
      }
      return year + "-" + month + "-" + day + "";
    },
    async getPageList(postUrl) {
      try {
        const { data: res } = await this.$http.get(
          postUrl,
          // "/server/api/content/news/website/search/getPageList",
          {
            params: this.queryInfo,
          }
        );
//         let res = {
//   "code": 200,
//   "msg": "查询成功",
//   "content": {
//     "list": [
//       {
//         "id": "2770ed1d-d4e4-4fdf-a396-6c3eeba856a1",
//         "name": "民航局相关司局，民航各地区管理局、空管局，各千万级机场所在地监管局，主要航空公司、机场公司在主会场、分会场参加会议",
//         "url": null,
//         "author": "23",
//         "introduction": "23",
//         "fileCoverId": "39e62c10-2518-42d4-9642-4306e3beb9ca",
//         "time": 1686067200000,
//         "publishStatus": 4,
//         "num": null,
//         "paragraphVoList": null,
//         "fileList": null,
//         "createUser": "王欢庆",
//         "createDate": 1686195183452,
//         "updateUser": "王欢庆",
//         "updateDate": 1686273974000,
//         "auditUser": "王欢庆",
//         "auditDate": 1686273971000,
//         "auditInfo": ""
//       }
//     ],
//     "totalPage": 1,
//     "currentPage": 1,
//     "total": 1
//   }
// }
        if (res.code == 200) {
          this.total = res.content.total;
          this.lineList = res.content.list;
          this.lineList.forEach((item, index) => {
            item.time = this.formate_Date(item.time);
            // 不需要封面
            // item.img =
            //   utils.imgURL +
            //   "/server/api/system/file/getFile?id=" +
            //   item.fileCoverId;
          });
        }
      } catch (e) {
        return false;
      }
    },

    handleClick(tab = "partyActivities", change) {
      if (change != "queryChange") {
        this.currentPage = 1;
        this.queryInfo.currentPage = 1;
      }
      this.activeName = tab;
      let postUrl = "";
      if (tab == "partyActivities") {
        (postUrl =
          "/server/api/content/partyActivities/website/search/getPageList"),
          this.getPageList(postUrl);
      } else if (tab == "committee") {
        (postUrl = "/server/api/content/committee/website/search/getPageList"),
          this.getPageList(postUrl);
      } else if (tab == "branchElegant") {
        (postUrl =
          "/server/api/content/branchElegant/website/search/getPageList"),
          this.getPageList(postUrl);
      } else if (tab == "learnResource") {
        (postUrl =
          "/server/api/content/learnResource/website/search/getPageList"),
          this.getPageList(postUrl);
      }
    },
    handleChange(val) {
      // console.log("当前页", val);
      this.currentPage = val;
      this.queryInfo.currentPage = val;
      this.handleClick(this.activeName, "queryChange");
    },
    goDetail(val) {
      if (!val.url) {
        // let routeData = "";
        // routeData = this.$router.resolve({
        //   path: `/about-us/PartyDetails`,
        //   query: {
        //     id: val.id,
        //     type: this.activeName,
        //   },
        // });
        // window.open(routeData.href, "_blank");
        this.$router.push({
          path: `/about-us/PartyDetails`,
          query: {
            id: val.id,
            type: this.activeName,
          },
        });
      } else {
        let urlStr = "";
        urlStr = val.url.indexOf("http") == -1 ? "https://" + val.url : val.url;
        window.open(urlStr);
      }
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/core-service.css";
</style>
<style scoped>
@import "../../assets/css/departmentsleft.css";
</style>
<style lang="less" scoped>
.itemBox:hover span:nth-of-type(1) {
  color: #409eff;
  cursor: pointer;
}


</style>
